import Model from 'flarum/common/Model';
export default class ExpLogs extends Model {
  user_id = Model.attribute('user_id');
  exp = Model.attribute('exp');
  type = Model.attribute('type');
  relationship = Model.attribute('relationship');
  created_at = Model.attribute('created_at');
}
flarum.reg.add('foskym-custom-levels', 'common/models/ExpLogs', ExpLogs);